import {
  AccessoryWithQuantityType,
  AirHandlerWithQuantityType,
  CondenserWithQuantityType
} from 'data/types';

export function combineProductQuantities<
  T extends
    | AccessoryWithQuantityType
    | AirHandlerWithQuantityType
    | CondenserWithQuantityType
>(products: T[]): T[] {
  return products.reduce((acc, product) => {
    const existingProductIndex = acc.findIndex(
      (p) => p.productId === product.productId
    );

    if (existingProductIndex !== -1) {
      acc[existingProductIndex] = {
        ...acc[existingProductIndex],
        quantity: acc[existingProductIndex].quantity + product.quantity
      };
    } else {
      acc.push(product);
    }

    return acc;
  }, [] as T[]);
}
